import React from 'react';
import { Checkbox } from '@/components/checkbox';
import { createStyles } from '@/contexts/theme-context';

interface Props {
  isSelected: boolean;
  onSelect: () => void;
}

export const GTINFilterCheckbox: React.FC<Props> = ({
  isSelected,
  onSelect,
}) => {
  const [styles, theme] = useStyles();

  return (
    <Checkbox
      checkProps={{
        stroke: theme.colors.accentText,
      }}
      getCheckboxStyle={(selected) => {
        return [
          styles.checkboxCheck,
          selected ? styles.checkboxCheckSelected : null,
        ];
      }}
      isSelected={isSelected}
      onSelect={onSelect}
      style={styles.checkbox}
      trackingData={null}
    />
  );
};

const CHECKBOX_SIZE = 20;
const useStyles = createStyles((theme) => ({
  checkbox: {
    paddingHorizontal: 0,
    paddingVertical: 8,
  },
  checkboxCheck: {
    backgroundColor: theme.colors.white,
    height: CHECKBOX_SIZE,
    width: CHECKBOX_SIZE,
  },
  checkboxCheckSelected: {
    backgroundColor: theme.colors.accent,
    borderColor: theme.colors.accent,
  },
}));
